import React from 'react'
import ContactMe from '../ContactMe/ContactMe'
import Header from '../Header/Header'
import ProjectCover from '../ProjectCover/ProjectCover'
import ProjectsList from '../ProjectsList/ProjectsList'

const ProjectPage = () => {
  return (
    <div>
      <Header/>
      <ProjectCover/>
      <ProjectsList/>
      <ContactMe/>
    </div>
  )
}

export default ProjectPage
